

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "./storage";
import Footer from "./Footer";
import Manubar from "./Manubar";
import DealCard from "./DealCard";
import "./loader.css";
import "./shubh.css";

const TABS = ["Popular", "Discount", "High Price", "Low Price"];

const FlashDealsListing = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const storeId = searchParams.get("store");
  const storeName = searchParams.get("storeName");
  const isStoreListing = Boolean(storeId);

  const token = secureLocalStorage.getItem("n_token");

  // Store listing → filter hamesha dikhega
  // Flash deals listing → filter sirf tab jab login nahi hai
  const showFilter = isStoreListing || !token;

  const pageTitle = isStoreListing ? `${storeName || "Store"} - Top Deals` : "Flash Deals";

  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activeTab, setActiveTab] = useState("Popular");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [appliedMin, setAppliedMin] = useState(null);
  const [appliedMax, setAppliedMax] = useState(null);
  const [brandSearch, setBrandSearch] = useState("");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [timeLeft, setTimeLeft] = useState(null);

  const fetchDeals = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        sort: activeTab,
        page: currentPage,
        limit: 20,
      });

      if (isStoreListing) {
        params.append("store_id", storeId);
        params.append("type", "normal");   // store page: only normal deals
      } else {
        params.append("type", "flash");    // flash page: only live flash deals
      }

      if (appliedMin !== null) params.append("minPrice", appliedMin);
      if (appliedMax !== null) params.append("maxPrice", appliedMax);

      const { data } = await axios.get(`${process.env.REACT_APP_API}website/deals?${params}`);
      if (data?.success) {
        setDeals(data.data);
        setTotalPages(data.pagination?.totalPages || 1);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, appliedMin, appliedMax, currentPage, storeId]);

  // Timer sirf tab dikhega jab list me koi expiry_time wali (flash) deal ho
  useEffect(() => {
    if (deals.length === 0) return;

    const validExpiries = deals
      .map((d) => d.expiry_time)
      .filter(Boolean)
      .map((t) => new Date(t).getTime());

    if (validExpiries.length === 0) {
      setTimeLeft(null);
      return;
    }

    const nearestExpiry = Math.min(...validExpiries);

    const tick = () => {
      const diff = nearestExpiry - Date.now();
      if (diff <= 0) {
        setTimeLeft("ENDED");
        setDeals((prev) =>
          prev.filter((d) => !d.expiry_time || new Date(d.expiry_time).getTime() > Date.now())
        );
        return;
      }
      const h = String(Math.floor(diff / 3600000)).padStart(2, "0");
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
      setTimeLeft(`${h}:${m}:${s}`);
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deals]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  const handleFilterGo = () => {
    setAppliedMin(minPrice ? Number(minPrice) : null);
    setAppliedMax(maxPrice ? Number(maxPrice) : null);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setMinPrice("");
    setMaxPrice("");
    setAppliedMin(null);
    setAppliedMax(null);
    setActiveTab("Popular");
    setBrandSearch("");
    setSelectedBrands([]);
    setCurrentPage(1);
  };

  const toggleBrand = (brandName) => {
    setSelectedBrands((prev) =>
      prev.includes(brandName) ? prev.filter((b) => b !== brandName) : [...prev, brandName]
    );
  };

  const brandList = Array.from(
    new Set(deals.filter((d) => d.store_id?.name).map((d) => d.store_id.name))
  );
  const visibleBrands = brandList.filter((b) => b.toLowerCase().includes(brandSearch.toLowerCase()));

  const displayedDeals =
    selectedBrands.length > 0 ? deals.filter((d) => selectedBrands.includes(d.store_id?.name)) : deals;

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div>
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content"><Manubar /></div>
        </div>
      </div>

      <div className="container px-3 px-md-4 py-4">
        <h2 className="text-center mb-4" style={{ color: "#1a1a2e", fontWeight: 800, fontSize: "28px" }}>
          {pageTitle}
        </h2>

        <div className="row g-4">
          {showFilter && (
            <div className="col-lg-3 col-md-4 mb-4">
              {(activeTab !== "Popular" || selectedBrands.length > 0 || appliedMin !== null) && (
                <div className="d-flex justify-content-end align-items-center mb-2">
                  <button
                    onClick={handleClearFilters}
                    style={{ background: "none", border: "none", color: "#f4511e", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
                  >
                    Clear
                  </button>
                </div>
              )}

              <div style={{ border: "1px solid #eee", borderRadius: 10, padding: 16 }}>
                <h6 className="fw-bold mb-3">Filters</h6>
                <div className="text-muted mb-2" style={{ fontSize: 13 }}>{pageTitle}</div>
                <hr />
                <div className="mb-3">
                  <strong style={{ fontSize: 14 }}>Price</strong>
                  <div className="d-flex gap-2 align-items-center mt-2">
                    <input type="number" placeholder="Min" value={minPrice} onChange={(e) => setMinPrice(e.target.value)} className="form-control form-control-sm" />
                    <span>-</span>
                    <input type="number" placeholder="Max" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className="form-control form-control-sm" />
                    <button onClick={handleFilterGo} className="btn btn-sm" style={{ background: "#f4511e", color: "#fff" }}>GO</button>
                  </div>
                </div>
                <hr />
                <div>
                  <strong style={{ fontSize: 14 }}>Brand</strong>
                  <input
                    type="text"
                    placeholder="Search Brand"
                    value={brandSearch}
                    onChange={(e) => setBrandSearch(e.target.value)}
                    className="form-control form-control-sm mt-2 mb-2"
                  />
                  {visibleBrands.map((b) => (
                    <div className="form-check mt-1" key={b}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedBrands.includes(b)}
                        onChange={() => toggleBrand(b)}
                        id={`brand-${b}`}
                      />
                      <label className="form-check-label" htmlFor={`brand-${b}`} style={{ fontSize: 14 }}>
                        {b}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className={showFilter ? "col-lg-9 col-md-8" : "col-12"}>
            <div className="sort-tabs">
              {TABS.map((tab) => (
                <button key={tab} onClick={() => handleTabClick(tab)} className={`sort-tab ${activeTab === tab ? "active" : ""}`}>
                  {tab}
                </button>
              ))}
            </div>

            {selectedBrands.length > 0 && (
              <div className="d-flex flex-wrap gap-2 mb-3 mt-3">
                {selectedBrands.map((b) => (
                  <span
                    key={b}
                    style={{ display: "inline-flex", alignItems: "center", gap: 8, border: "1px solid #ddd", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 500 }}
                  >
                    BRAND: {b}
                    <span onClick={() => toggleBrand(b)} style={{ cursor: "pointer", fontWeight: 700 }}>×</span>
                  </span>
                ))}
              </div>
            )}

            {timeLeft && timeLeft !== "ENDED" && (
              <div className="text-center mt-4 mb-4">
                <span
                  className="d-inline-flex align-items-center gap-2 text-white fw-semibold"
                  style={{ background: "#e8491d", borderRadius: "20px", padding: "8px 20px", fontSize: "14px" }}
                >
                  <i className="las la-clock"></i>
                  Ends in {timeLeft}
                </span>
              </div>
            )}

            {loading ? (
              <div className="row justify-content-center pb-5"><div className="loader"></div></div>
            ) : (
              <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-2" style={{ marginTop: "25px" }}>
                {displayedDeals.length > 0 ? (
                  displayedDeals.map((deal) => (
                    <div className="col" key={deal._id}>
                      <DealCard deal={deal} onClick={() => navigate(`/deal/${deal.slug}`)} />
                    </div>
                  ))
                ) : (
                  <p className="text-center text-muted">No Deals Available</p>
                )}
              </div>
            )}

            <div className="text-center p-4">
              <button className="pagination-button" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>Previous</button>
              {pageNumbers.map((page) => (
                <button key={page} onClick={() => setCurrentPage(page)} className={`pagination-button ${page === currentPage ? "pagiactive" : ""}`}>{page}</button>
              ))}
              <button className="pagination-button" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>Next</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FlashDealsListing;